import { skipToken } from '@reduxjs/toolkit/query/react'
import { FleetTruckCounts } from '@numeo/types-main-web-app'
import { useAppSelector } from '@/hooks'
import { useGetFleetTruckCountsQuery } from '@/store/api/fleetTrucksApi'
import { selectTeamApplicationId } from '../team/useTeamDirectoryEnabled'

/**
 * The company's truck counts (total, active, terminated, manual without ELD, per ELD integration): `GET
 * /fleet/trucks/counts/v1`, so no screen reads the whole fleet to count it. Read again when trucks change.
 */
export const useFleetTruckCounts = (options: { skip?: boolean } = {}): { counts: FleetTruckCounts | undefined; isLoading: boolean; isError: boolean } => {
    const applicationId = useAppSelector(selectTeamApplicationId)
    const result = useGetFleetTruckCountsQuery(!options.skip && applicationId ? { applicationId } : skipToken)
    return { counts: result.data, isLoading: result.isLoading, isError: result.isError }
}
